import { weekTimeline } from "@/mocks/guagua";
import SectionHead from "./SectionHead";

const weekColor = ["bg-primary-500", "bg-accent-500", "bg-secondary-600", "bg-primary-500", "bg-accent-500"];

export default function WeekReview() {
  return (
    <section id="week" className="scroll-mt-24 lg:scroll-mt-[132px] py-12 md:py-16">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6">
        <SectionHead
          kicker="BENZHOU·DASHI"
          title="本周大事件盘点"
          desc="一周热点一次看完，从热搜登顶到口碑逆转，为你梳理本周最值得吃的五场大瓜。"
          align="center"
        />
        <div className="relative mt-10">
          <span className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-background-200"></span>
          <div className="space-y-5">
            {weekTimeline.map((e, i) => (
              <div key={i} className={`relative flex ${i % 2 ? "md:justify-end" : ""}`}>
                <span className="hidden md:flex absolute left-1/2 -translate-x-1/2 top-6 w-3 h-3 rounded-full bg-background-50 border-4 border-primary-500 z-10"></span>
                <div className={`md:w-[46%] w-full rounded-2xl border border-background-200 bg-background-100 p-5 md:p-6 flex gap-4 ${i % 2 ? "md:mr-[4%] md:flex-row-reverse md:text-right" : "md:ml-[4%] text-left"}`}>
                  <div className="shrink-0">
                    <span className={`inline-flex flex-col items-center justify-center w-14 h-14 rounded-xl text-background-50 ${weekColor[i]}`}>
                      <span className="font-label text-lg leading-none">{e.day}</span>
                      <span className="text-[10px] leading-none mt-0.5 opacity-90">{e.date}</span>
                    </span>
                  </div>
                  <div>
                    <div className="flex items-center gap-2 flex-wrap">
                      <h3 className="font-heading font-bold text-foreground-950 leading-snug">{e.title}</h3>
                    </div>
                    <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{e.desc}</p>
                    <span className="mt-3 inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs">
                      <i className="ri-fire-line"></i> {e.heat}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}